const mutations = {

  SET_EVENT_VIDEOS: (state, data) => (state.event_videos = data),
  SET_HAS_VIDEO_REQUEST: (state, data) => (state.has_video_request = data),
  SET_VIDEO_REQUESTS: (state, data) => (state.video_requests = data),
}

export default mutations
